<template>
  <div>
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>
      <div class="account-box">
        <div>HI～ {{userInfo.name}}</div>
        <div class="line">|</div>
        <div>所属机构：{{userInfo.institutionName}}</div>
        <div class="line">|</div>
        <div>账号：{{userInfo.username}}</div>
        <div class="line">|</div>
        <div class="change-password">
          <i class="el-icon-my-change-password"></i>
          <span @click="showDialog = true" style="display: block;margin-left:5px">修改密码</span>
        </div>
        <!-- <div class="avatar-wrapper">
          <img class="user-avatar" src="https://yizhen-mamapai-test.oss-cn-zhangjiakou.aliyuncs.com/certification/2023-09-12/d060df8eb60747c384b124a948508123.png" />
        </div> -->
        <div class="line">|</div>
        <div class="log-out">
          <i class="el-icon-my-log-out"></i>
          <span @click="logout" style="display: block;margin-left:5px">退出登录</span>
        </div>
      </div>
    </el-menu>
    <login-dialog :show-dialog="showDialog" @close="close"></login-dialog>
  </div>
</template>

<script>
import "../../login/el-css.css"; // 自定义icon
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import LoginDialog from "@/components/loginDialog";
export default {
  data() {
    return {
      showDialog: false,
      defaultImg: "@/assets/images/avatar.png"
    };
  },
  components: {
    Breadcrumb,
    Hamburger,
    LoginDialog
  },
  computed: {
    ...mapGetters(["sidebar", "avatar"]),
    userInfo() {
      let userMsg = JSON.parse(window.localStorage.getItem("userInfo"));
      return userMsg;
    }
  },
  created() {
    if (this.userInfo.isPasswordReset == 1) {
      this.showDialog = true;
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    close() {
      this.showDialog = false;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      .user-avatar {
        width: 35px;
        height: 35px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}

.account-box {
  position: absolute;
  right: 30px;
  top: 0;
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  .line {
    margin: 0 20px;
    color: #eeeeee;
  }
  .change-password {
    display: flex;
    align-items: center;
  }
  .log-out {
    display: flex;
    align-items: center;
  }
  .avatar-wrapper {
    cursor: pointer;
    margin-top: 20px;
    margin-left: 10px;
    position: relative;
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 10px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue